/**
 * 會員方案常數（B 端唯一資料來源）
 *
 * 兩方案制：
 *   - basic = 一般方案、brand = 高階方案（現行可新購）
 *   - business = 商務方案，已停售，既有客戶權益不變
 *   - free = 試用版
 *
 * 建立這支檔案的原因：在此之前方案顯示名稱散落在至少 7 個檔案，
 * 出現「小資方案 / 基礎方案 / 基礎 / 免費方案 / 商務方案 / 品牌方案」等
 * 六種互不一致的寫法。新增顯示方案名稱的地方請一律 import 本檔。
 *
 * 對應後端：beauty-server/shared/config/planLimits.js 的 PLAN_DISPLAY_NAME
 */

// 方案代碼
export const PLAN = {
  FREE: 'free',
  BASIC: 'basic',
  BRAND: 'brand',
  BUSINESS: 'business'
}

// 顯示名稱（完整）
export const PLAN_DISPLAY_NAME = {
  free: '試用版',
  basic: '一般方案',
  brand: '高階方案',
  business: '商務方案（舊方案）'
}

// 顯示名稱（精簡，給表格／標籤等空間有限處用）
export const PLAN_SHORT_NAME = {
  free: '試用',
  basic: '一般',
  brand: '高階',
  business: '商務（舊）'
}

// 標籤顏色
export const PLAN_COLOR = {
  free: '#9E9E9E',
  basic: '#4CAF50',
  brand: '#FF8F00',
  business: '#2196F3'
}

/**
 * 現行可新購的方案（不含已停售的 business）
 * 註冊頁、升級頁、admin 指派方案的下拉選單都應該用這個。
 */
export const SELLABLE_PLANS = ['free', 'basic', 'brand']

/**
 * 已停售的方案。仍存在於既有店家資料中，顯示時要標示「舊方案」，
 * 但不可作為新購或升級的引導對象。
 */
export const LEGACY_PLANS = ['business']

/**
 * 取得方案顯示名稱
 * @param {string} plan
 * @param {boolean} short 是否使用精簡名稱
 */
export const getPlanName = (plan, short = false) => {
  const map = short ? PLAN_SHORT_NAME : PLAN_DISPLAY_NAME
  return map[plan] || plan || '未知方案'
}

/** 是否為已停售的舊方案 */
export const isLegacyPlan = (plan) => LEGACY_PLANS.includes(plan)
